import { faBox, faCube, faReceipt, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AMBER, BLUE, DANGER, NAVY, SUCCESS } from "../constants";
import { formatCurrency, formatInteger, formatPercent } from "../formatters";
import { SummaryCard } from "./SummaryCard";

export function SummaryCardsRow({ summary, isSummaryLoading }) {
  return (
    <section className="mt-6 grid grid-cols-1 gap-4 xl:grid-cols-5">
      <SummaryCard
        label="Total Cons (Completed and Reportable)"
        value={isSummaryLoading ? "…" : formatInteger(summary.totalConsignments)}
        trend={summary.consignmentsQoqPct}
        trendSuffix="vs. prev quarter"
        icon={faBox}
        accent={NAVY}
        rulesKey="summaryTotalConsignments"
      />
      <SummaryCard
        label="Total Spend"
        value={isSummaryLoading ? "…" : formatCurrency(summary.totalSpend)}
        trend={summary.spendQoqPct}
        trendSuffix="vs. prev quarter"
        icon={faReceipt}
        accent={BLUE}
        rulesKey="summaryTotalSpend"
      />
      <SummaryCard
        label="DIFOT %"
        value={isSummaryLoading ? "…" : formatPercent(summary.difotPct)}
        trend={summary.difotQoqChange}
        trendSuffix="vs. prev quarter"
        accent={summary.difotPct >= 90 ? SUCCESS : summary.difotPct >= 75 ? AMBER : DANGER}
        ring={isSummaryLoading ? undefined : summary.difotPct}
        rulesKey="summaryDifot"
      />
      <SummaryCard
        label="Damage and Losses %"
        value={isSummaryLoading ? "…" : formatPercent(summary.dlRate)}
        trend={summary.dlQoqChange}
        trendSuffix="vs. prev quarter"
        icon={faTriangleExclamation}
        accent={DANGER}
        inverse
        rulesKey="summaryDamageLoss"
      />
      <SummaryCard
        label="POD %"
        value={isSummaryLoading ? "…" : formatPercent(summary.podRate)}
        trend={summary.podQoqChange}
        trendSuffix="vs. prev quarter"
        icon={faCube}
        accent={SUCCESS}
        rulesKey="summaryPod"
      />
    </section>
  );
}
